import React, { useState } from 'react';

export default function Contact() {
  const [formStatus, setFormStatus] = useState('idle');

  const handleSubmit = (e) => {
    e.preventDefault();
    setFormStatus('submitting');
    
    // Simulate API call for form submission
    setTimeout(() => {
      setFormStatus('success');
      e.target.reset();
    }, 1000);
  };

  return (
    <div className="animate-view" style={{ maxWidth: '600px', margin: '0 auto' }}>
      <div className="folder-card" style={{ flexDirection: 'column', alignItems: 'stretch' }}>
        <h2 style={{ marginBottom: '16px', fontSize: '24px', color: 'var(--text-primary)' }}>
          Get in Touch
        </h2>
        <p style={{ color: 'var(--text-secondary)', marginBottom: '24px' }}>
          Have a question about our educational materials or need support? Drop us a message below.
        </p>

        {formStatus === 'success' ? (
          <div style={{ padding: '16px', background: 'var(--success-bg)', color: 'var(--success)', borderRadius: '8px', textAlign: 'center' }}>
            Message sent successfully! We'll get back to you soon.
          </div>
        ) : (
          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            <div>
              <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '500' }}>Name</label>
              <input 
                type="text" 
                required 
                style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid var(--border)', fontFamily: 'inherit' }}
                placeholder="Your Name"
              />
            </div>
            
            <div>
              <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '500' }}>Email</label>
              <input 
                type="email" 
                required 
                style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid var(--border)', fontFamily: 'inherit' }}
                placeholder="your@email.com"
              />
            </div>

            <div>
              <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '500' }}>Message</label>
              <textarea 
                required 
                rows="4"
                style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid var(--border)', fontFamily: 'inherit', resize: 'vertical' }}
                placeholder="How can we help?"
              />
            </div>

            <button 
              type="submit" 
              className="btn-primary" 
              disabled={formStatus === 'submitting'}
              style={{ width: '100%', marginTop: '8px', border: 'none' }}
            >
              {formStatus === 'submitting' ? 'Sending...' : 'Send Message'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}